import React, {useState} from "react";
import "./Orders.scss";
import {OnlineCard} from "./OnlineCard";
import {OfflineCard} from "./OfflineCard";
import {OnlineTab} from "./OnlineTab";
import {OfflineTab} from "./OfflineTab";
import {useHistory} from "react-router-dom";
import {Nav} from "../../Components";
function Orders() {

    const history = useHistory()
    const [tabIndex,set_tabIndex] = useState(1)

    return(
        <div className="orders-container">
            <div className="report-header">
                <span>سفارشات من</span>
                <i
                    onClick={() => history.goBack()}
                    className="fa fa-arrow-left"></i>
            </div>
            {/*<div className="orders-tabs">*/}
            {/*    <span className={tabIndex===2?"active":""} onClick={()=>{set_tabIndex(2)}}>خرید حضوری</span>*/}
            {/*    <span className={tabIndex===1?"active":""} onClick={()=>{set_tabIndex(1)}}>خرید آنلاین</span>*/}
            {/*</div>*/}
            <div className="orders-body">
                {tabIndex===1?<div className="orders-online">
                    <OnlineTab/>
                </div>:null}
                {tabIndex===2?<div className="orders-offline">
                    <OfflineTab/>
                </div>:null
                }
            </div>
            <Nav/>
        </div>
        )
}

export {Orders};
